import { AdminTerminal } from '../model/adminTerminal';
import { Location } from '../model/location';
import { AdminTerminalInfo } from '../model/adminTerminalInfo';
import { ProductBuilder } from './product-builder';
export class AdminTerminalBuilder {
    static buildAdminTerminal(data) {
        let adminTerminal = new AdminTerminal();
        adminTerminal = Object.assign({}, data);
        return adminTerminal;
    }
    static buildLocationObject(obj) {
        let locationObj = new Location(obj.lat, obj.lng);
        return locationObj;
    }
    static buildData(check) {
        let data = {};
        for (let info in check) {
            if (check[info] instanceof Array) {
                data[info] = _.map(check[info], (_check) => {
                    return ProductBuilder.buildInfoSection(_check);
                });
            }
            else {
                data[info] = this.buildLocationObject(check[info]);
            }
        }
        return data;
    }
    static buildAdminTerminalInfo(data) {
        const adminTerminalInfo = new AdminTerminalInfo();
        adminTerminalInfo.product_terminal_id = data.product_terminal_id;
        adminTerminalInfo.terminal_id = data.terminal_id;
        adminTerminalInfo.product_id = data.product_id;
        adminTerminalInfo.common_terminal_id = data.common_terminal_id;
        adminTerminalInfo.checkin_es = this.buildData(data.checkin_es);
        adminTerminalInfo.checkin_ca = this.buildData(data.checkin_ca);
        adminTerminalInfo.checkin_fr = this.buildData(data.checkin_fr);
        adminTerminalInfo.checkin_en = this.buildData(data.checkin_en);
        adminTerminalInfo.checkout_es = this.buildData(data.checkout_es);
        adminTerminalInfo.checkout_ca = this.buildData(data.checkout_ca);
        adminTerminalInfo.checkout_fr = this.buildData(data.checkout_fr);
        adminTerminalInfo.checkout_en = this.buildData(data.checkout_en);
        return adminTerminalInfo;
    }
}
//# sourceMappingURL=adminTerminal-builder.js.map